import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface ListContainerProps {
	title: ReactNode;
	subtitle?: ReactNode;
	children: ReactNode;
	className?: string;
	rightContent?: ReactNode;
}

export default function ListContainer({ title, subtitle, children, className, rightContent }: ListContainerProps) {
	return (
		<div
			className={classNames(
				'flex flex-col h-full bg-white rounded-lg border border-gray-200 overflow-hidden',
				className,
			)}
		>
			<div className="bg-gray-50 p-4 border-b border-gray-200 flex justify-between items-center">
				<div>
					<div className="text-lg font-bold">{title}</div>
					{subtitle && <span className="text-sm font-medium text-gray-500">{subtitle}</span>}
				</div>
				{rightContent && <div>{rightContent}</div>}
			</div>
			<div className="flex-1 overflow-y-auto p-4">{children}</div>
		</div>
	);
}
